import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = {
	auth: true
}

export default {
	path: '/member',
	name: 'member',
	meta,
	redirect: {
		name: 'member-index'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'archives',
			name: `${pre}archives`,
			component: _import('member/archivesList'),
			meta: {
				...meta,
				title: '会员档案'
			}
		},
		{
			path: 'signContract',
			name: `${pre}signContract`,
			component: _import('member/signContractList'),
			meta: {
				...meta,
				title: '签约列表'
			}
		},
		{
			path: 'statistics',
			name: `${pre}statistics`,
			component: _import('member/statistics'),
			meta: {
				...meta,
				title: '统计数据'
			}
		},
		{
			path: 'mockMember',
			name: `${pre}mockMember`,
			component: _import('member/mockMember'),
			meta: {
				...meta,
				title: '虚拟用户管理'
			}
		},
	])('member-')
}